import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { AssociateType } from "../../../components/filter/types/AssociateType";
import { fetchAssociatePansions } from "../thunks/fetchAssociatePansions";
import { IAssociateState } from "../types/IAssociateState";
import { selectMatchingItems } from "../utils/selectMatchingItems";
import { updateSuggestedOnFetchComplete } from "./utils/updateSuggestedOnFetchComplete";

export const addFetchAssociatePansions = (builder: ActionReducerMapBuilder<IAssociateState>) => {
  builder.addCase(fetchAssociatePansions.pending, (state, action) => {
    state.loadingKeys = [...state.loadingKeys, `${action.meta.arg.operator}`];
  });
  builder.addCase(fetchAssociatePansions.rejected, (state, action) => {
    state.loadingKeys = state.loadingKeys.filter((itm) => itm !== `${action.meta.arg.operator}`);
  });
  builder.addCase(fetchAssociatePansions.fulfilled, (state, action) => {
    state.loadingKeys = state.loadingKeys.filter((itm) => itm !== `${action.meta.arg.operator}`);
    state.pansions[action.meta.arg.operator] = [...action.payload];

    if (action.meta.arg.noSuggestions !== true) {
      selectMatchingItems(
        state.operators.map((itm) => itm.id),
        state,
        state.tezTargets,
        action.meta.arg.operator,
        AssociateType.pansions,
      );
      updateSuggestedOnFetchComplete(state, action.meta.arg.operator, action.payload);
    }
  });
};
